import { createRouter, createWebHashHistory } from 'vue-router'

// 路由配置数组
const routes = [
    // 默认重定向到登录页
    {
        path: '/',
        redirect: '/supplier/login'
    },
    
    // 供应商登录页（无需权限）
    {
        path: '/supplier/login',
        name: 'SupplierLogin',
        component: () => import('../views/supplier/SupplierLogin.vue'),
        meta: { requiresAuth: false }
    },

    // 供应商工作台（需登录权限）
    {
        path: '/supplier',
        name: 'SupplierLayout',
        component: () => import('../views/supplier/SupplierLayout.vue'),
        meta: { requiresAuth: true },
        redirect: '/supplier/index',
        children: [
            {
                path: '/supplier/index',
                name: 'SupplierIndex',
                component: () => import('../views/supplier/IndexPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/supplier/book',
                name: 'SupplierBook',
                component: () => import('../views/supplier/BookPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/supplier/schools',
                name: 'SupplierSchools',
                component: () => import('../views/supplier/SchoolsPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/supplier/order',
                name: 'SupplierOrder',
                component: () => import('../views/supplier/OrderPage.vue'),
                meta: { requiresAuth: true }
            }
        ]
    },
    
    {
        path: '/:pathMatch(.*)*',
        name: 'ErrorPage',
        component: () => import('../views/supplier/SupplierLayout.vue'),
        meta: { requiresAuth: false }
    }
]

// 创建路由实例
const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL), // hash模式（URL带#）
    routes
})

// 全局路由守卫（权限控制）
router.beforeEach((to, from, next) => {
    // 从localStorage读取token
    const token = localStorage.getItem('token') || ''
    // 1. 无需权限的页面直接放行
    if (!to.meta.requiresAuth) {
        return next()
    }

    // 2. 需要权限的页面：有token放行，无token跳回对应登录页
    if (token) {
        next()
    } else {
        localStorage.clear()
        // 根据路径判断跳转到哪个登录页
        if (to.path.includes('/supplier/')) {
            next('/supplier/login')
        } else {
            next('/supplier/login')
        }
    }
})

export default router
